import { cryptoService } from '@/services/cryptoService.js'
import { mapActions } from 'vuex'
import * as device from '@/utilities/deviceUtils.js'

const SHARE_PREFIX = 'share-'
const isStaging = process.env.NODE_ENV === 'staging'

export default {
  computed: {
    shareMixin_locale() {
      return this.$store.state.i18nStore.locale
    }
  },

  methods: {
    ...mapActions('i18nStore', ['updateLocale']),

    /* pack / unpack id */

    shareMixin_prepId(id) {
      const newId = id + `?l=${this.shareMixin_locale}`
      return SHARE_PREFIX + cryptoService.encrypt(newId)
    },

    shareMixin_extractId(sharedLink) {
      const parseQuery = (queryString) => {
        let params = {}
        const pairs = queryString?.split('&') || []
        for (const pair of pairs) {
          const param = pair.split('=')
          params[decodeURIComponent(param[0])] = decodeURIComponent(param[1] || '')
        }
        return params
      }

      // decrypt the link
      const link = sharedLink.startsWith(SHARE_PREFIX)
        ? cryptoService.decrypt(sharedLink.replace(SHARE_PREFIX, ''))
        : sharedLink
      const [id, queryString] = link.split('?')

      // process query params
      if (queryString) {
        const params = parseQuery(queryString)
        const locale = params['l']
        if (locale) this.updateLocale({ locale, vm: this })
      }

      // return the decrypted id
      return id
    },

    /* enable share menu */

    async shareMixin_shareItem(item) {
      return this.shareMixin_shareEntity({
        id: item.id,
        abstract: item.abstract || item.subtitle || '',
        title: item.title,
        routeName: 'player'
      })
    },

    async shareMixin_sharePost(post) {
      return this.shareMixin_shareEntity({
        id: post.id,
        abstract: post.excerpt || '',
        title: post.title,
        routeName: 'post'
      })
    },

    async shareMixin_shareChannel(channel) {
      return this.shareMixin_shareEntity({
        id: channel.slug,
        abstract: channel.abstract || '',
        title: channel.title,
        routeName: 'channel'
      })
    },

    async shareMixin_shareEntity({ id, abstract, title, routeName }) {
      if (isStaging) {
        const ok = confirm('Are you sure you want to share a link in staging?')
        if (!ok) return
      }
      const shareableId = this.shareMixin_prepId(id)
      // check whether native sharing is supported
      if (window.navigator.share && !device.isMac()) {
        try {
          await navigator.share({
            title: title,
            text: abstract,
            url: `${window.location.origin}/${routeName}/${shareableId}`
          })
        } catch (error) {
          console.error('[shareMixin]:', error)
        }
        // null indicates that native sharing was attempted
        return null
      } else {
        // return a canonical share entity for use in a modal
        return { id, abstract, title, routeName }
      }
    }
  }
}
